import React from 'react';
import { ImagePlaceholder } from './ImagePlaceholder';
const stats = [{
  percent: 93,
  text: 'Notó reducción visible de la hinchazón abdominal'
}, {
  percent: 88,
  text: 'Reportó más energía y menos antojos durante el día'
}, {
  percent: 91,
  text: 'Sintió que la ropa volvió a quedarle mejor'
}, {
  percent: 85,
  text: 'Durmió mejor y se levantó con más energía'
}, {
  percent: 89,
  text: 'Afirmó sentirse más liviana y en control de su cuerpo'
}];
export function Resultados() {
  return <section className="bg-white py-16 px-4" data-id="element-218">
      <div className="max-w-6xl mx-auto bg-esbelta-lavender rounded-3xl p-6 md:p-12 flex flex-col md:flex-row gap-10 items-center" data-id="element-219">
        <div className="w-full md:w-1/2" data-id="element-220">
          <div className="w-full rounded-2xl overflow-hidden shadow-lg bg-white" data-id="element-221">
            <img src="https://cdn.magicpatterns.com/uploads/o7ohqZ1P5xMVKufr4PhkVM/heylloyd-image-1781547816350.png" alt="Antes y después tomando ESBELTA®" className="w-full h-auto object-contain" data-id="element-222" />
          </div>
        </div>

        <div className="w-full md:w-1/2" data-id="element-223">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-esbelta-violet mb-4" data-id="element-224">
            Resultados comprobados 💜
          </h2>
          <p className="text-gray-700 mb-8" data-id="element-225">
            Basado en una encuesta interna a más de{' '}
            <strong className="text-gray-900" data-id="element-226">800 mujeres argentinas</strong>{' '}
            que tomaron ESBELTA® durante 30 días.
          </p>

          <div className="space-y-6" data-id="element-227">
            {stats.map((stat, idx) => <div key={idx} className="flex items-center gap-4" data-id="element-228">
                <div className="relative w-14 h-14 flex-shrink-0 flex items-center justify-center" data-id="element-229">
                  <svg className="w-full h-full -rotate-90" viewBox="0 0 36 36" data-id="element-230">
                    <path className="text-white" strokeWidth="3" stroke="currentColor" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" data-id="element-231" />
                    <path className="text-esbelta-violet" strokeWidth="3" strokeDasharray={`${stat.percent}, 100`} stroke="currentColor" fill="none" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" data-id="element-232" />
                  </svg>
                  <span className="absolute text-sm font-bold text-esbelta-violet" data-id="element-233">
                    {stat.percent}%
                  </span>
                </div>
                <p className="text-gray-800 font-medium text-sm md:text-base leading-tight" data-id="element-234">
                  {stat.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}